import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  width: ', 'px;\n  height: 12px;\n  border-radius: 4px;\n  background-color: ', ';\n\n  &:after {\n    content: \'\';\n    display: block;\n    height: 100%;\n    background-color: ', ';\n    width: ', 'px;\n    transition: width 0.2s ease;\n    border-radius: 4px;\n  }\n'], ['\n  width: ', 'px;\n  height: 12px;\n  border-radius: 4px;\n  background-color: ', ';\n\n  &:after {\n    content: \'\';\n    display: block;\n    height: 100%;\n    background-color: ', ';\n    width: ', 'px;\n    transition: width 0.2s ease;\n    border-radius: 4px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  margin-bottom: 8px;\n'], ['\n  color: ', ';\n  margin-bottom: 8px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  z-index: 3;\n  background: rgba(255, 255, 255, 0.8);\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: default;\n'], ['\n  position: absolute;\n  z-index: 3;\n  background: rgba(255, 255, 255, 0.8);\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: default;\n']);

import React from 'react';
import styled from 'styled-components';
import { styles } from 'gipsy-misc';

var BASE_PROGRESS_WIDTH = 100;

var ProgressBar = styled.div(_templateObject, BASE_PROGRESS_WIDTH, styles.colors.borderColor, styles.colors.borderColorFocus, function (_ref) {
  var progress = _ref.progress;
  return progress / 100 * BASE_PROGRESS_WIDTH;
});

var TextContainer = styled.div(_templateObject2, styles.colors.borderColorFocus);

var Container = styled.div(_templateObject3);

export default (function (_ref2) {
  var progress = _ref2.progress,
      text = _ref2.text;

  return React.createElement(
    Container,
    { onClick: function onClick(e) {
        return e.stopPropagation();
      } },
    React.createElement(
      TextContainer,
      null,
      text
    ),
    React.createElement(ProgressBar, { progress: progress })
  );
});
//# sourceMappingURL=Loader.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/DraftEditor/Loader.js
// module id = 992
// module chunks = 0